export default __webpack_public_path__ + "static/media/leader_notes_detailed.bf317b26.pdf";